import { render, staticRenderFns } from "./AdminDistrictsView.vue?vue&type=template&id=dc849e9e&scoped=true&"
import script from "./AdminDistrictsView.vue?vue&type=script&lang=js&"
export * from "./AdminDistrictsView.vue?vue&type=script&lang=js&"
import style0 from "./AdminDistrictsView.vue?vue&type=style&index=0&id=dc849e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc849e9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
